import { makeObservable, observable, flow, computed, action } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import BrowseControlWatchlistSchema from "@/areas/compliance/schemas/BrowseControlWatchlistSchema";

export default class BrowseControlWatchlistStore {
  loading = true;
  pagination = null;
  watchlistControls = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      watchlistControls: observable,
      actions: computed,
      consume: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }
  get processing() {
    return this.loading;
  }

  get actions() {
    const list = [];

    return list;
  }

  consume(watchlistControl) {
    const index = this.watchlistControls.findIndex((e) => e.id === watchlistControl.id);
    if (index !== -1) {
      this.watchlistControls.splice(index, 1, watchlistControl);
      this.watchlistControls = [...this.watchlistControls];
    }
  }

  *load(query, options) {
    const parseResult = BrowseControlWatchlistSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;

      const response = yield api.post(ApiRoutes.forControlSearch(), {
        ...query,
        query: { ...query.query, inWatchlist: true },
      });
      this.watchlistControls = response.data.items;
      console.log("response", response);

      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
